import React from 'react'

const BlockContext = React.createContext({ lightBox: null })

export const BlockProvider = BlockContext.Provider

export default BlockContext
